// extracted by css-extract-rspack-plugin
export default {"container":"q7FVM","close_button_override":"ccsa1","closeButtonOverride":"ccsa1","#":"PDLEY","icon":"CMV12","label":"Oe6TP","button_override":"U80xE","buttonOverride":"U80xE"};